/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { initialState } from './reducer';

export const selectFeaturesDictionaryDomain = state => state.FeaturesDictionaryReducer || initialState;
export const selectRouterDomain = state => state.router || {};

export const getIsDictionaryDataLoadingSelector = () =>
	createSelector(selectFeaturesDictionaryDomain, ({ isDictionaryDataLoading }) => isDictionaryDataLoading);

export const getDictionaryDataSelector = () =>
	createSelector(selectFeaturesDictionaryDomain, ({ dictionaryData }) => {
		if (!dictionaryData || dictionaryData.length === 0) {
			return [];
		}

		return dictionaryData;
	});

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'features');
	});
